import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({
    name: 'daysDiff'
})
export class DaysDiffPipe implements PipeTransform {
    transform(date1: Date, date2: Date): number {
        return differenceInDays(date2, date1);
    }
}
